import { render, staticRenderFns } from "./ChartDimensions.vue?vue&type=template&id=d5cd7686&scoped=true&"
import script from "./ChartDimensions.vue?vue&type=script&lang=js&"
export * from "./ChartDimensions.vue?vue&type=script&lang=js&"
import style0 from "./ChartDimensions.vue?vue&type=style&index=0&id=d5cd7686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cd7686",
  null
  
)

export default component.exports